import { PolicyTermSearchResponse } from '@lio/api-types';

/** Given an array of policyTerms return the number of terms the policy has had */
export function getCurrentTermCount(policyTerms?: PolicyTermSearchResponse['items']) {
  if (!policyTerms) {
    return 0;
  }

  const activePolicyTerm = policyTerms.find((term) => term.status === 'Active');
  if (activePolicyTerm) {
    return activePolicyTerm.termCount;
  }

  const expiredPolicyTerms = policyTerms.filter((term) => term.status === 'Expired');
  if (expiredPolicyTerms?.length > 0) {
    // find most recent expired
    expiredPolicyTerms.sort((a, b) => new Date(b.effectiveOn).getTime() - new Date(a.effectiveOn).getTime());
    return expiredPolicyTerms[0].termCount;
  }

  return 0;
}
